import { gsap } from 'gsap';
import { SplashView } from '../SplashController';
import { BitmapTextStyleOptions } from '../../../../core/setting/text/IText';
import { GameAssets } from '../../../GameAssets';
import { BitmapCountUp } from '../../../../core/component/BitmapCountUp';
import { Helper } from '../../../../core/utils/Helper';
import { SpinePlayer } from '../../../../core/displayobject/SpinePlayer';
import { FontWeight } from '@nolimitcity/slot-launcher/bin/loader/font/FontStatics';
import { Beheaded } from '../../../Beheaded';
import { SoundConfig } from '../../../config/sound/SoundConfig';

export class SplashViewFreeSpins extends PIXI.Container implements SplashView {
    private poster: SpinePlayer;
    private counter: BitmapCountUp;
    private _text: PIXI.Sprite;

    private readonly _style: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_BIG_WIN_COUNT_UP,
        fontSize: 22,
        tint: 0xffffff,
        letterSpacing: 0,
    };

    private _timeLine: gsap.core.Timeline;

    constructor() {
        super();
        this.init();
    }

    private init(): void {
        this.poster = this.addChild(new SpinePlayer('sfsIntro', true));
        this.poster.position.set(0, -100);
        this.poster.scale.set(0.7, 0.7);

        this._text = new PIXI.Sprite(Beheaded.assetLoader.getTextures('sfsSpinText')[0]);
        this._text.anchor.set(0.5, 0.5);
        this._text.position.set(0, 125);

        this.counter = this.addChild(new BitmapCountUp(this._style));
        this.counter.alpha = 1;
        this.counter.anchor = new PIXI.Point(0.5, 0.5);

        this.addChild(this._text, this.counter);
        this.visible = false;
    }

    public play(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(
            this._timeLine,
            new gsap.core.Timeline({
                onStart: () => {
                    this.visible = true;
                },
            })
        );
        let count: number = 0;
        if (Beheaded.model.data.isRestoreState) {
            count = Beheaded.model.initData.freespinsLeft;
        } else {
            count = Beheaded.model.gameData.freespinsLeft;
        }

        this.counter.showValue(count, false);
        this.counter.alpha = count > 0 ? 1 : 0;
        this._timeLine.fromTo(this, { alpha: 0 }, { duration: 0.5, alpha: 1 }, 0);

        this._timeLine.add(
            this.poster.play({
                animation: 'intro',
                showOnEnd: true,
                onComplete: () => {
                    this.poster.play({ animation: 'intro_loop', loop: true });
                },
            }),
            0
        );

        // SoundManager.playSoundEffect(this.introSound);
        // SoundManager.emptyLoop();

        if (!Beheaded.model.data.isRestoreState) {
        }
        Beheaded.overlayBG.flagShow(false);
        Beheaded.backgroundCharacter.playLevelUpSounds(0, false, true);
        Beheaded.soundPlayer.playSound(SoundConfig.FS_INTRO_START);
        Beheaded.soundPlayer.playSound(SoundConfig.FS_INTRO);

        return this._timeLine;
    }

    public stop(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(
            this._timeLine,
            new gsap.core.Timeline({
                onStart: () => {
                    Beheaded.soundPlayer.stopSound(SoundConfig.LVL_START_5_BUY);
                    Beheaded.soundPlayer.stopSound(SoundConfig.FS_INTRO);
                    Beheaded.soundPlayer.playSound(SoundConfig.FS_START);
                    Beheaded.soundPlayer.playSound(SoundConfig.LVL_5);
                    Beheaded.backgroundCharacter.isLevelSoundActive = true;
                },
                onComplete: () => {
                    this.visible = false;
                    this.poster.reset();
                },
            })
        );
        this._timeLine.to(this, { duration: 0.35, alpha: 0 });
        return this._timeLine;
    }

    public onResize(): void {
        if (this._timeLine) this._timeLine.progress(1);
    }
}
